import { IModule, ICourse } from 'interface/course';
import { useCallback, useEffect, useState } from 'react';
import courseService from 'services/course';
import RegisterElasticCertificateEvent from 'services/registerElasticCertificateEvent';

export const useCourseProgress = (modules: IModule[], course?: ICourse) => {
  const [progress, setProgress] = useState(0);
  const [certificateUrl, setCertificateUrl] = useState(null);

  const { progress_percent, certificate_url, hash } = course;

  const calcPercent = useCallback((lessons: number, watched: number) => {
    if (lessons > 0 && watched >= 0) {
      return Math.floor((watched / lessons) * 100);
    }
    return 0;
  }, []);

  const getCertificate = useCallback(() => {
    if (!certificate_url && hash) {
      courseService.getCertificateUrl(hash).then(setCertificateUrl);
    } else if (certificate_url) {
      setCertificateUrl(certificate_url);
    }
  }, [certificate_url, hash]);

  const registerCertificateEvent = () => {
    const register = new RegisterElasticCertificateEvent(course.hash, progress, certificateUrl, course.title);
    register.emit();
  };

  useEffect(() => {
    if (!modules || !Array.isArray(modules)) return;

    const lessons = modules.flatMap((module) => module.lessons);
    const watchedLessons = lessons.filter((lesson) => lesson.watched);

    setProgress(calcPercent(lessons.length, watchedLessons.length));
  }, [modules, calcPercent]);

  useEffect(() => {
    const reachedMinimun = progress >= progress_percent;
    if (reachedMinimun) {
      getCertificate();
    } else {
      setCertificateUrl(null);
    }
  }, [progress, progress_percent, getCertificate]);

  return { progress, certificateUrl, registerCertificateEvent, reachedMinimum: progress >= progress_percent };
};
